'use strict';

var base = require('./base');
var baseDetail = require('base/product/detail');
var addToCartToast = require('../utils/addToCartToast');
var stickySidebar = require('../utils/customStickySidebar');
var pdpGallery = require('./lvzPdpGallery');
var productScarcity = require('../components/productScarcity');
var productQuantityStepper = require('../components/productQuantityStepper');
var notifyMe = require('../components/notifyMe');
var pendingRefillState = null;

function forceStopPageLoader() {
	if ($.spinner && $.spinner().forceStop) {
		$.spinner().forceStop();
	}
}

// processInclude may run these initializers more than once per page, and webpack scope
// hoisting can inline this module into several chunks of the same bundle. Bind every
// delegated handler through a namespace and clear it first, so a single interaction never
// triggers duplicate Product-Variation requests regardless of how many times we run.

/**
 * Resolves the active quantity field (select or input) scoped to the closest product container (PDP, quick view, modal).
 * @param {Object} $el - jQuery DOM element
 * @returns {Object} - jQuery DOM element of the quantity field
 */
function getStepperQuantityField($el) {
	var $container = $el && $el.length ? $($el).closest('.product-detail') : $();
	if (!$container.length) {
		$container = $($el).closest('.quick-view-dialog').find('.product-detail');
	}
	if (!$container.length) {
		$container = $($el).closest('.modal-content').find('.product-quickview');
	}
	if (!$container.length) {
		$container = $('.product-detail').first();
	}

	var $refillOptions = $container.find('.product-refill-options.lvz-pdp-refill').first();
	if ($refillOptions.length) {
		var $selectedQuantity = $refillOptions
			.find('input[type=radio]:checked')
			.closest('.lvz-pdp-refill__option')
			.find('select.product-qty, input.product-qty')
			.first();

		if ($selectedQuantity.length) {
			return $selectedQuantity;
		}
	}

	return $container.find('select.product-qty, input.product-qty').first();
}

function refreshRefillNiceSelect($context) {
	$(document).trigger('update:nice-select', {
		$context: $context && $context.length ? $context : $('.product-refill-options.lvz-pdp-refill')
	});
}

function getSelectedRefillOptionType($refillOptions) {
	var checkedId = ($refillOptions.find('input[type=radio]:checked').attr('id') || '').split('-')[0];
	return checkedId || 'purchaseOneTime';
}

function getRefillQuantityValue($refillOptions) {
	var $qty = $refillOptions
		.find('input[type=radio]:checked')
		.closest('.lvz-pdp-refill__option')
		.find('select.product-qty, input.product-qty')
		.first();

	if (!$qty.length) {
		$qty = $refillOptions.find('select.product-qty, input.product-qty').first();
	}

	return $qty.length ? $qty.val() : '';
}

function captureRefillState($refillOptions) {
	if (!$refillOptions || !$refillOptions.length) {
		return;
	}

	pendingRefillState = {
		optionType: getSelectedRefillOptionType($refillOptions),
		quantity: getRefillQuantityValue($refillOptions),
		deliveryEvery: $refillOptions.find('.deliveryEvery').val(),
		limitedSubscription: $refillOptions.find('.limitedSubscription').val()
	};
}

function syncRefillQuantities($refillOptions, quantity) {
	if (!quantity) {
		return;
	}

	$refillOptions.find('.lvz-pdp-refill__quantity select.product-qty').each(function () {
		var $select = $(this);
		if ($select.find('option[value="' + quantity + '"]').length) {
			$select.val(quantity);
			productQuantityStepper.syncQtyStepperUI($select);
		}
	});
}

/** Copies selected refill option list/sales/PPU into the PDP sticky bar. */
function syncStickyBarFromRefill($refillOptions) {
	if (!$refillOptions || !$refillOptions.length) {
		return;
	}
	var $container = $refillOptions.closest('.product-detail');
	var $bar = $container.find('[data-lvz-pdp-sticky-bar]').first();
	if (!$bar.length || $bar.is('[data-lvz-pdp-sticky-full-site]')) {
		return;
	}
	var $checked = $refillOptions.find('input[type=radio]:checked');
	if (!$checked.length) {
		return;
	}
	var $option = $checked.closest('.lvz-pdp-refill__option');
	var $priceBlock = $option.hasClass('lvz-pdp-refill__option--limited')
		? $refillOptions.find('.lvz-pdp-refill__option--recurring .lvz-pdp-refill__price, .sor-price-container').first()
		: $option.find('.lvz-pdp-refill__price--one-time, .lvz-pdp-refill__price, .sor-price-container').first();
	if (!$priceBlock.length) {
		return;
	}
	var listText = $priceBlock.find('.lvz-pdp-refill__price-old').first().text().trim();
	var salesText = $priceBlock.find('.lvz-pdp-refill__price-current, .sor-price').first().text().trim();
	var $priceInner = $bar.find('.lvz-pdp-sticky-bar__prices .price').first();
	if (!$priceInner.length) {
		return;
	}
	var $root = $('<span></span>');
	if (listText) {
		$root.append(
			$('<del></del>').append(
				$('<span class="strike-through list"></span>').append(
					$('<span class="value"></span>').text(listText)
				)
			)
		);
	}
	$root.append(
		$('<span></span>')
			.addClass(listText ? 'sales discount' : 'sales')
			.append($('<span class="value"></span>').text(salesText))
	);
	$priceInner.empty().append($root);
	var ppuText = $priceBlock.find('[data-price-per-unit]').first().text().trim();
	$bar.find('.lvz-pdp-sticky-bar__price-row [data-price-per-unit]')
		.first()
		.text(ppuText)
		.toggleClass('d-none', !ppuText);
}

function updateRefillOptionVisibility($options) {
	var $checked = $options.find('input[type=radio]:checked');
	var $checkedOption = $checked.closest('.lvz-pdp-refill__option');
	var checkedId = $checked.attr('id') || '';
	var isRefill = $checked.val() === 'true';

	$options
		.find(
			'.smart-order-refill-period, .delivery-every-message, .limited-subscription-message-container, .lvz-pdp-refill__quantity, .lvz-pdp-refill__scarcity, .lvz-pdp-refill__benefits'
		)
		.hide();
	$options.find('input[name=isRegularSubscription]').val('false');

	if (!isRefill) {
		syncStickyBarFromRefill($options);
		return;
	}
	if (checkedId.startsWith('deliveryEvery')) {
		$options.find('input[name=isRegularSubscription]').val('true');
		$options.find('.delivery-every-message').css('display', 'inline-block');
	} else {
		$options.find('.limited-subscription-message-container').css('display', 'inline-block');
	}
	syncStickyBarFromRefill($options);
}

function restoreRefillState($context) {
	var state = pendingRefillState;
	var $refillOptions = ($context && $context.length ? $context : $(document))
		.find('.product-refill-options.lvz-pdp-refill')
		.first();

	if (!state || !$refillOptions.length) {
		return;
	}

	var $radio = $refillOptions.find('input[type=radio][id^="' + state.optionType + '-"]').first();
	if ($radio.length) {
		$radio.prop('checked', true);
	}
	if (state.deliveryEvery) {
		$refillOptions.find('.deliveryEvery').val(state.deliveryEvery);
	}
	if (state.limitedSubscription) {
		$refillOptions.find('.limitedSubscription').val(state.limitedSubscription);
	}

	syncRefillQuantities($refillOptions, state.quantity);
	updateRefillOptionVisibility($refillOptions);
	refreshRefillNiceSelect($refillOptions);
}

/**
 * Qty +/- must not call Product-Variation. The stepper syncs data-qty and add to cart
 * reads the select. Variation refresh stays on swatch and pack only.
 * Refill options still mirror the selected quantity locally.
 */
function availability() {
	$(document).off('change.lvzStepperAvailability', 'select.product-qty');
	$(document).on('change.lvzStepperAvailability', 'select.product-qty', function (e) {
		e.preventDefault();
		if ($(this).hasClass('bonus-quantity-select')) {
			return;
		}

		var $refillOptions = $(this).closest('.product-refill-options.lvz-pdp-refill');
		if (!$refillOptions.length) {
			return;
		}

		let value = $(this).val();
		$refillOptions.find('.lvz-pdp-refill__quantity select.product-qty').not(this).each(function () {
			$(this).val(value);
			productQuantityStepper.syncQtyStepperUI($(this));
		});
		captureRefillState($refillOptions);
	});
}

/**
 * Hooks base SFRA updateAddToCartFormData to overwrite form.quantity with the value read from the new stepper select.
 */
function injectStepperQuantityInAddToCartForm() {
	refreshRefillNiceSelect();

	$(document).off('updateAddToCartFormData.lvzStepperQty');
	$(document).on('updateAddToCartFormData.lvzStepperQty', function (e, form) {
		if (!form) {
			return;
		}
		var $qty = getStepperQuantityField($(e.target));
		if ($qty.length) {
			var qty = parseInt($qty.val(), 10);
			if (!isNaN(qty) && qty > 0) {
				form.quantity = qty;
			}
		}

		var pid = form.pid;
		var $refillOptions = pid ? $('.product-refill-options[data-pid="' + pid + '"]') : $();
		if (!$refillOptions.length) {
			return;
		}
		var $checkedRefill = $refillOptions.find('input[type=radio]:checked');
		var checkedRefillId = $checkedRefill.attr('id') || '';
		var isRecurring = $checkedRefill.val() === 'true';
		var isDeliveryEvery = checkedRefillId.startsWith('deliveryEvery');

		delete form['deliveryEverySelection-' + pid];
		delete form['limitedSubscriptionSelection-' + pid];

		if (isRecurring) {
			form['hasSmartOrderRefill-' + pid] = 'true';
			form.isRegularSubscription = isDeliveryEvery ? 'true' : 'false';
			if (isDeliveryEvery) {
				form['deliveryEverySelection-' + pid] = $refillOptions.find('.deliveryEvery').val();
			} else {
				form['limitedSubscriptionSelection-' + pid] = $refillOptions.find('.limitedSubscription').val();
			}
		} else {
			form['hasSmartOrderRefill-' + pid] = 'false';
			form.isRegularSubscription = 'false';
		}

		var refillSig = 'onetime';
		if (isRecurring) {
			var freqVal = isDeliveryEvery
				? form['deliveryEverySelection-' + pid]
				: form['limitedSubscriptionSelection-' + pid];
			if (freqVal) {
				var parts = String(freqVal).split('-');
				var interval = parts[0];
				var periodicity = parts[1];
				var shipments = parts.length > 2 ? parseInt(parts[2], 10) : 0;
				if (interval && periodicity) {
					refillSig =
						(periodicity === 'week' ? 'w:' : 'm:') +
						interval +
						(shipments > 0 ? ':s:' + shipments : '');
				}
			}
		}
		form.lvzAddRefillSignature = refillSig;
	});

	$(document).off('change.lvzRefillOptions', '.product-refill-options input[type=radio]');
	$(document).on('change.lvzRefillOptions', '.product-refill-options input[type=radio]', function () {
		var $options = $(this).closest('.product-refill-options');
		captureRefillState($options);
		updateRefillOptionVisibility($options);
	});

	$(document).off('ajaxComplete.lvzRefillNiceSelect');
	$(document).on('ajaxComplete.lvzRefillNiceSelect', function (_event, _xhr, settings) {
		if (!settings || !settings.url || settings.url.indexOf('SmartOrderRefillController-PDPRefillOptions') === -1) {
			return;
		}

		restoreRefillState($('.refill-options-container'));
	});

	syncStickyBarFromRefill($('.product-detail .product-refill-options.lvz-pdp-refill').first());

	$('body').off('product:beforeAttributeSelect.lvzRefillState');
	$('body').on('product:beforeAttributeSelect.lvzRefillState', function (e, data) {
		var $container = data && data.container && data.container.length ? data.container : $('.product-detail');
		captureRefillState($container.find('.product-refill-options.lvz-pdp-refill').first());
	});
}

/**
 * Rebuilds the stepper options and resyncs its display after a variation change (base SFRA `updateQuantities` targets the legacy select).
 */
function refreshStepperAfterAttributeSelect() {
	$('body').off('product:afterAttributeSelect.lvzStepperRefresh');
	$('body').on('product:afterAttributeSelect.lvzStepperRefresh', function (e, response) {
		if (!response || !response.data || !response.data.product) {
			return;
		}
		var $container = response.container && response.container.length ? response.container : $('.product-detail');
		var pricePerUnit = response.data.product.pricePerUnit || response.data.product.PricePerUnit;
		var displayValue = pricePerUnit && pricePerUnit.displayValue ? pricePerUnit.displayValue : '';
		$container.find('[data-price-per-unit]').text(displayValue).toggleClass('d-none', !displayValue);
		if (response.data.product.totalBeans != null) {
			var beans = response.data.product.totalBeans || 0;
			$container.find('.beans-worth').toggleClass('d-none', !beans).find('.beans').text(beans);
		}
		productQuantityStepper.updateQuantities(response.data.product, $container);
		productScarcity.updateScarcity(response.data.product, $container);
		var product = response.data.product;
		var sales = product.price && product.price.sales;
		var $qty = getStepperQuantityField($container);
		var mcpAttrs = {
			'data-sku': product.id || '',
			'data-price': sales ? String(sales.decimalPrice || sales.value || '') : '',
			'data-qty': $qty.val() || '1'
		};
		$container.attr(mcpAttrs);
		$container.find('button.add-to-cart').attr(mcpAttrs);
		const disabled =
			!product.readyToOrder || !product.available || !product.hasPrice;
		$container.find('button.add-to-cart').prop('disabled', disabled);
		syncStickyBarFromRefill($container.find('.product-refill-options.lvz-pdp-refill').first());
	});
}

/** Initializes the PDP gallery sticky sidebar after sibling modules (e.g. sticky bar) have run. */
function initPdpStickySidebar() {
	if (!$('.product-detail .gallery.lvz-sticky-sidebar').length) {
		return;
	}

	var initialize = function () {
		window.requestAnimationFrame(function () {
			window.requestAnimationFrame(function () {
				stickySidebar.initStickySidebar({
					containerSelector: '.product-detail > .lvz-sticky-sidebar__container'
				});
				stickySidebar.updateStickySidebar();
			});
		});
	};

	if (document.readyState === 'complete') {
		initialize();
	} else {
		$(window).one('load.pdpStickySidebar', initialize);
	}
}

baseDetail.availability = availability;
baseDetail.injectStepperQuantityInAddToCartForm = injectStepperQuantityInAddToCartForm;
baseDetail.refreshStepperAfterAttributeSelect = refreshStepperAfterAttributeSelect;

/**
 * Replaces SFRA updateAddToCart so Product-Variation also disables ATC when hasPrice is false.
 */
function updateAddToCart() {
	$('body').off('product:updateAddToCart.lvzHasPrice');
	$('body').on('product:updateAddToCart.lvzHasPrice', function (e, response) {
		if (!response || !response.product || !response.$productContainer) {
			return;
		}

		const disabled =
			!response.product.readyToOrder ||
			!response.product.available ||
			!response.product.hasPrice;

		$('button.add-to-cart', response.$productContainer).attr('disabled', disabled);

		let enable = $('.product-availability')
			.toArray()
			.every(function (item) {
				return $(item).data('available') && $(item).data('ready-to-order');
			});
		if (!response.product.hasPrice) {
			enable = false;
		}
		if (baseDetail.methods && baseDetail.methods.updateAddToCartEnableDisableOtherElements) {
			baseDetail.methods.updateAddToCartEnableDisableOtherElements(!enable);
		}
	});
}

baseDetail.updateAddToCart = updateAddToCart;

module.exports = Object.assign({}, baseDetail, {
	colorAttribute: base.colorAttribute,

	addToCartToast: function () {
		$('body').off('product:afterAddToCart.lvzAddToCartToast');
		$('body').on('product:afterAddToCart.lvzAddToCartToast', function (e, data) {
			if (data.newBonusDiscountLineItem && Object.keys(data.newBonusDiscountLineItem).length !== 0) {
				forceStopPageLoader();
				window.setTimeout(forceStopPageLoader, 0);
				return;
			}

			$('.add-to-basket-alert').remove();
			$('.add-to-cart-messages').empty();

			addToCartToast.show({
				message: data.error ? data.message : undefined,
				quantityTotal: data.quantityTotal,
				error: data.error,
			});
		});
	},
	notifyMe: notifyMe,
	initPdpStickySidebar: initPdpStickySidebar,
});
